// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"260":"401bb3f1","319":"81a133bd","660":"f28109fc","838":"73f800d8"}[chunkId] + ".css";
};